import { render } from "./ConsComprobanteContable.vue?vue&type=template&id=5788489c&scoped=true"
import script from "./ConsComprobanteContable.vue?vue&type=script&lang=js"
export * from "./ConsComprobanteContable.vue?vue&type=script&lang=js"

import "./ConsComprobanteContable.vue?vue&type=style&index=0&id=5788489c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5788489c"]])

export default __exports__